module.exports = __webpack_public_path__ + "img/dash-desk.ee1a88bb.png";